module.exports = __webpack_public_path__ + "static/sophie-0489793971c5bb4762a87efec7ab0dfd.png";